window.ntfInit = ntfInit;
window.emailSignUpM_New = emailSignUpM_New;

function  ntfInit(cookieName, sectionURL, department, subscribeSource) {
    //cookieName = <%=NewToFileUtils.NAME_COOKIE_NTF_NO_RIBBON%>
    //sectionURL = <%=p.sectionUrl%>
    //department = <%=ntf_department%>
    if(!window.rcProps || !window.rcProps.ntf){
        return;
    }
    if($('#ntf-toast-mobile').length === 0 && $('#ambassador-share-link').length === 0)  {
        $('.fixed-bottom').addClass("u-width--auto");
        $('.fixed-bottom__flex').addClass("u-margin-l--none");
    }
    $('.fixed-bottom').removeClass('u-hide');
    var ntfData = window.rcProps.ntf;
    function parseRtn(rtn){
        return JSON && JSON.parse(rtn) || $.parseJSON(rtn);
    }
    $("#email_signup_form").find("input").on('change keyup paste', function () {
        $(this).removeClass("error");
        $(this).attr("placeholder", "");
    });
    $(document).on( "click", ".js-ntf-restriction-modal", function(){
        $.modal({
            url:"/content/homepage/ntfDialog/NTF_TOAST_RESTRICTION",
            type: "toast",
            triggerOpen: true,
            onClose: function () {
                loadNtfPopups("NTF_TOAST_NEW");
            }
        });
     });

    $("#ntf-toast-mobile-close").on("click", function () {
        setCookie(cookieName, true, 1);
        $('.fixed-bottom').addClass("u-width--auto");
        $('.fixed-bottom__flex').addClass("u-margin-l--none");

    });

    $("#ntf-email-address_container").focus( function() {
        $("#ntf_email_wrapper").removeClass("is-error");
        $("#email-error-feedback_rev_mobile").text("").hide();
    })


    // for mock purposes, updating flow of footer sign up form
    window.ntfToastFormSubmit = function (event) {
        event.preventDefault();
        $("#ntf_email_wrapper").removeClass("is-error");
        $("#email-error-feedback_rev_mobile").text("").hide();
        var input = $("#ntf-email-address");
        var value = input.val();
        // checks if email exists
        if (value == '') {
            markFooterEmailFieldAsError(ntfData.missingEmailMessage);
        } else if (!validateEmail(value)) {
            markFooterEmailFieldAsError(ntfData.invalidEmailMessage);
        } else {
            var params = {};
            params['emailAddress'] = input.val();
            params['sectionURL'] = sectionURL;
            params['subscriptionGender'] = department;
            if (subscribeSource && subscribeSource.length > 0) {
                params['subscribeSource'] = subscribeSource;
            }

            if(window.rcProps.ga4TagID) {
                if(typeof gtag === 'undefined') {
                    window.dataLayer = window.dataLayer || [];
                    function gtag() {
                        dataLayer.push(arguments);
                    }
                    gtag('js', new Date());
                    gtag('config', window.rcProps.ga4TagID);
                    gtag('event', 'get_coupon', {
                        'coupon_name': 'get 10% off',
                        'sent_to': window.rcProps.ga4TagID
                    });
                }

            }


            $.ajax({
                url: '/r/ajax/NtfDialogSubmit.jsp',
                data: params,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                type: "POST",
                cache: false,
                success: function (msg) {
                    var msgJson = JSON.parse(msg);
                    var result = msgJson[ntfData.keySubmitResult];
                    var promoCode = msgJson[ntfData.keySubmitPromoCode];
                    var isIneligibleEmail;

                    if (result == ntfData.submitIneligible) { // testcancel@revolvemail.com
                        isIneligibleEmail = true;
                        $("#ntf-toast-mobile").hide();
                        $("#ntfUserEmailExisting").html(input.val());
                        loadNtfPopups( "NTF_TOAST_EXISTING");
                        setCookie("ntfUserInelligible", true, 365);
                        setCookie(cookieName, true, 365);
                    } else if (result == ntfData.submitIneligiblePurchased) { // testcancel@revolvemail.com
                        isIneligibleEmail = true;
                        $("#ntf-toast-mobile").hide();
                        $("#ntfUserEmailExisting").html(input.val());
                        loadNtfPopups( "NTF_TOAST_EXISTING");
                        setCookie("ntfUserInelligiblePurchased", true, 365);
                        setCookie(cookieName, true, 365);
                    } else if (result == ntfData.submitNewCode || result == ntfData.submitCodexists  || result == ntfData.submitNewCodeSms) {
                        // trigger event on form success
                        $("#ntf-toast-mobile").hide();
                        var additionalData  = {};
                        additionalData.email = input.val();
                        additionalData.promoCode = promoCode;
                        if(result == ntfData.submitNewCodeSms) {
                            loadNtfPopups("NTF_TOAST_STEP2");
                        } else {
                            loadNtfPopups( "NTF_TOAST_NEW", additionalData);
                        }
                        setCookie("ntfUserInelligibleSuccess", true, 365);
                        setCookie(cookieName, true, 365);
                    } else if (result == ntfData.submitInvalid || result == ntfData.submitInvalidHighIPActivity) {
                        if (result != ntfData.submitInvalidHighIPActivity) {
                            markFooterEmailFieldAsError(ntfData.invalidEmailMessage);
                        } else {
                            markFooterEmailFieldAsError(ntfData.highIPUsageMessage);
                        }
                    } else {
                        console.log("Possible programming error: result not recognized, result[" + result + "], promoCode[" + promoCode + "]");
                    }
                }
            });
        }
    };
}
// for mock purposes, updating flow of footer sign up form
function emailSignUpM_New(event, department, sectionURL, cookieName, subscribeOnly) {
    event.preventDefault();
    var $triggerElement = $(event.currentTarget);
    $triggerElement.prop('disabled', true);
    var input = $('#email_signup_form--input');
    if (subscribeOnly) {
        input = $('#email_signup_form--input_subscribe');
    }
    var value = input.val();
    if (value == '') {
        // checks error for input field
        // back end to update error state
        input.val("");
        input.attr("placeholder","Invalid email. Please try again");
        input.addClass("error");
        $triggerElement.prop('disabled', false);
    } else if (subscribeOnly) {
        const emailForm = $("#email_signup__form_subscribe");
        const params = {};
        params['email'] = value;
        params['gender'] = department;
        params['sectionURL'] = sectionURL;
        params['mobile'] = 'true';
        $.get( "/r/ajax/SignUpForNewsletter.jsp", params, function( r ) {
            var msg =  $.parseJSON(r);
            if(msg.success) {
                emailForm.find("span").eq(0).show();
                emailForm.find("input").hide();
                emailForm.find("span").eq(1).hide();
                location.href="/r/mobile/email/subscribe_landing_m.jsp?email="+ value;
            } else {
                input = emailForm.find("input");
                input.val("");
                input.attr("placeholder",msg.msg0);
                input.addClass("error");
            }
        });
    } else {
        var params = {};
        params['emailAddress'] = input.val();
        params['sectionURL'] = sectionURL;
        params['subscriptionGender'] = department;
        $.ajax({
            url: '/r/ajax/NtfDialogSubmit.jsp',
            data: params,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            type: "POST",
            cache: false,
            success: function (msg) {
                var msgJson = JSON.parse(msg);
                var result = msgJson[ntfData.keySubmitResult];
                var promoCode = msgJson[ntfData.keySubmitPromoCode];
                var isIneligibleEmail;
                if (result == ntfData.submitIneligible) { // testcancel@revolvemail.com
                    isIneligibleEmail = true;
                    $("#ntf-toast-mobile").hide();
                    $("#ntfUserEmailExisting").html(input.val());
                    loadNtfPopups( "NTF_TOAST_EXISTING", undefined, $triggerElement);
                    setCookie("ntfUserInelligible", true, 365);
                    setCookie(cookieName, true, 365);
                } else if (result == ntfData.submitIneligiblePurchased) { // testcancel@revolvemail.com
                    isIneligibleEmail = true;
                    $("#ntf-toast-mobile").hide();
                    var data = {
                        "email" : input.val(),
                    }
                    loadNtfPopups( "NTF_TOAST_EXISTING", data, $triggerElement);
                    setCookie("ntfUserInelligiblePurchased", true, 365);
                    setCookie(cookieName, true, 365);
                } else if (result == ntfData.submitNewCode || result == ntfData.submitCodexists || result == ntfData.submitNewCodeSms) {
                    // trigger event on form success
                    $("#ntf-toast-mobile").hide();
                    $("#ntfUserEmail").html(input.val());
                    $("#personalizeProfileMobileNtf").attr("href", "/r/mobile/email/subscribe_landing_m.jsp?email="+input.val()+"&homePage=true");
                    $(".ntfCouponCode").html(promoCode);
                    var data = {
                        "promoCode" : promoCode,
                        "email" : input.val(),
                    }
                    if(result == ntfData.submitCodexists){
                        loadNtfPopups( "NTF_TOAST_EXISTING", data, $triggerElement);
                    }else {
                        loadNtfPopups("NTF_TOAST_NEW", data, $triggerElement);
                    }
                    if(result == ntfData.submitNewCodeSms) {
                        loadNtfPopups("NTF_TOAST_STEP2");
                    } else {
                        loadNtfPopups( "NTF_TOAST_NEW", data);
                    }
                    setCookie("ntfUserInelligibleSuccess", true, 365);
                    setCookie(cookieName, true, 365);
                    logEngagement(window.location.href, "revolve_global_footer", "email_signup_to_redeem_the_10%_off_coupon", params);
                } else if (result == ntfData.submitInvalid || result == ntfData.submitInvalidHighIPActivity) {
                    if (result != ntfData.submitInvalidHighIPActivity) {
                        input.val("");
                        input.attr("placeholder","Invalid email. Please try again");
                    } else {
                        pleaseTryAgainLaterFooter();
                    }
                    $triggerElement.prop('disabled', false);
                } else {
                    $triggerElement.prop('disabled', false);
                    console.log("Possible programming error: result not recognized, result[" + result + "], promoCode[" + promoCode + "]");
                }
            }
        });
    }

    if(window.rcProps.ga4TagID) {
        if(typeof gtag === 'undefined'){
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', window.rcProps.ga4TagID);
        }

        if(typeof gtag !== 'undefined') {
            gtag('event', 'newsletter_signup', {
                'send_to': window.rcProps.ga4TagID
            });
        }
    }
}

function validateEmail(email){
    var emailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegEx.test(email);
}

function pleaseTryAgainLaterFooter() {
    $("#email_signup_form--input").val("");
    $("#email_signup_form--input").attr("placeholder","Too many requests. Please try tomorrow ");
}

function markFooterEmailFieldAsError(errorMessage) {
    $("#email-error-feedback_rev_mobile").text(errorMessage).show();
    $("#ntf_email_wrapper").addClass("is-error");
}


// WEBPACK FOOTER //
// ./src/scripts/modules/ntf.js